import { render, staticRenderFns } from "./FeatureRow.vue?vue&type=template&id=23c7c10e&"
import script from "./FeatureRow.vue?vue&type=script&lang=js&"
export * from "./FeatureRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports